export default __webpack_public_path__ + "static/media/assessment_glide_6_2.8690fbd8.svg";